<template>
  <div class="slides">
    <div ref="slides" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(promotion, key) in promotions"
          :key="key"
          class="swiper-slide"
          :style="{ backgroundImage: `url(${promotion.image_768 ? promotion.image_768 : promotion.image_400})` }"
        ></div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
  name: 'Promotions',
  props: {
    promotions: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(this.$refs.slides, {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      speed: 800,
    });
  },
};
</script>

<style lang="scss">
.slider-scan-qr-promos {
  .slides {
    margin-bottom: 20px;
    height: 290px;
  }
  .swiper-container {
    width: 100%;
    height: 100% !important;
    .swiper-pagination-bullet {
      background: #fff !important;
      opacity: 0.6 !important;
      width: 16px !important;
      height: 16px !important;
      margin: 0 8px !important;
    }
    .swiper-pagination-bullet:focus {
      outline: none;
    }
    .swiper-pagination-bullet-active {
      background: #b02956 !important;
      opacity: 1 !important;
    }
  }

  .swiper-slide {
    text-align: center;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    width: 100%;
    height: 312px;
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 30px;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 21px 0 0;
    /* &:last-child {
		      margin-right: 0;
		  }  */
  }
}
@media (min-width: 769px) and (max-width: 1920px) {
  .slider-scan-qr-promos {
    .swiper-slide {
      height: 440px;
    }
  }
}
</style>
